var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex align-items-center"},[_c('div',{staticClass:"flex-grow-1"},[(_vm.isAdmin)?_c('ManageALFApprovers'):_vm._e()],1),(_vm.isCreate)?_c('search-recipient'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }